import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["controls", "seats", "decrement", "increment", "seatCount", "monthly", "annual", "error"]
  static values = { price: Number, months: Number }

  connect() {
    this.currency = new Intl.NumberFormat("en", { style: "currency", currency: "EUR", maximumFractionDigits: 0 })
    this.controlsTarget.hidden = false
    this.calculate()
  }

  decrement() {
    this.seatsTarget.stepDown()
    this.calculate()
  }

  increment() {
    this.seatsTarget.stepUp()
    this.calculate()
  }

  calculate() {
    const input = this.seatsTarget
    const seats = input.valueAsNumber
    const monthly = seats * this.priceValue
    const annual = monthly * this.monthsValue
    const valid = input.validity.valid && Number.isSafeInteger(seats) && Number.isSafeInteger(annual)
    input.setAttribute("aria-invalid", String(!valid))
    this.errorTarget.hidden = valid
    let error = `Enter a whole number from ${input.min} to ${input.max} seats.`
    if (seats < Number(input.min)) error = `Minimum ${input.min} seats.`
    if (seats > Number(input.max)) error = `Maximum ${input.max} seats.`
    this.errorTarget.textContent = error
    this.seatCountTarget.textContent = valid ? `${seats} seats` : "Enter team size"

    this.decrementTarget.disabled = !valid || seats <= Number(input.min)
    this.incrementTarget.disabled = !valid || seats >= Number(input.max)
    this.annualTarget.textContent = valid ? this.currency.format(annual) : "—"
    this.monthlyTarget.textContent = valid ? `Equivalent to ${this.currency.format(monthly)} / month` : "Enter a valid seat count."
  }
}
